import { Form } from "@renderbus/ui";
import styled, { createGlobalStyle } from "styled-components";
import { ThemeType } from "task-eva-ui";

export const ModalStyle = createGlobalStyle`
  .task-eva-modal-inner-wrapper {
    border: 1px solid ${(p) => (p.theme as ThemeType)["color-line-1" as any]};
    background: ${(p) => (p.theme as ThemeType)["theme-1" as any]};
    overflow: hidden;
    ::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${(p) => (p.theme as ThemeType)["gradient-fill-7" as any]};
    }
  }
  .task-eva-modal-title {
    margin: 0;
    background: ${(p) => (p.theme as ThemeType)["color-fill-11" as any]};
    color: ${(p) => (p.theme as ThemeType)["color-text-1" as any]};
    font-size: 14px;
    font-weight: 600;
    line-height: 40px;
  }
  .close-icon-wrapper {
    top: 12px;
    svg path{
      stroke: #506265;
    }
  }
  .task-eva-modal-footer {
    margin: 6px 0 12px;
  }
  .modal-cancel-button {
    background-color: #8C9CA6;
    width: 104px;
    height: 30px;
    color: #FFFFFF;
  }
  .modal-confirm-button {
    background-color: #3C7BEA;
    width: 104px;
    height: 30px;
    color: #FFFFFF;
  }
  .modal-confirm-button:disabled {
    background-color: #3C7BEA;
  }
`;

export const RechargeVoucherWrapper = styled.div``;
export const RechargeVoucherTitle = styled.div`
  color: ${(p) => p.theme["color-text-4"]};
  font-size: 12px;
  cursor: pointer;
`;

export const RechargeForm = styled(Form)`
  padding: 45px 20px 0;
  height: 172px;
  .title {
    color: ${(p) => p.theme["color-text-1"]};
    font-size: 12px;
    font-weight: 400;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
  .client-coupon-code-input {
    height: 40px;
    margin: 8px 0 4px;
    input {
      background: ${(p) => p.theme["theme-1"]};
      color: ${(p) => p.theme["color-text-1"]};
      border: 1px solid ${(p) => p.theme["color-line-2"]};
      border-radius: 6px;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
  }
  .ant-form-item {
    .icon-input-wrapper {
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid ${(p) => p.theme["color-line-1"]} !important;
      background: ${(p) => p.theme["theme-1"]};
      color: ${(p) => p.theme["color-text-1"]};
    }
    &.ant-form-item-has-error {
      .icon-input-wrapper {
        border: 1px solid #ff1b1b !important;
        border-radius: 4px;
        color: #ff1b1b;
      }
    }
    .ant-form-item-explain-error {
      color: #ff1b1b;
    }
  }
`;
